module.exports = "./img/1db6f1c292a0e465657fc5ef0f3d0284.jpg";